import React from 'react'

import CountryMarketFaqSection from './CountryMarketFaqSection'
import { useVisitorMarket } from '../../hooks/useVisitorMarket'

/** Client/SPA only — requires React Router (not used during static SSR). */
const CountryMarketFaqFromGeo: React.FC = () => {
  const { market, isLoading } = useVisitorMarket()

  if (isLoading || !market) {
    return null
  }

  return <CountryMarketFaqSection market={market} />
}

export default CountryMarketFaqFromGeo
